import React from 'react';

function ServicesDeepFoundationsSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '80px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    inner: {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 50%',
      maxWidth: 640,
      minWidth: 280,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    rightCol: {
      flex: '1 1 380px',
      maxWidth: 636,
      minWidth: 300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      minHeight: 0
    },
    overlineRow: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 16
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 14,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      width: 80,
      height: 2,
      background: '#E73123'
    },
    titleRow: {
      marginBottom: 24
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: 0
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      color: '#838383',
      margin: '0 0 24px 0'
    },
    capabilitiesHeading: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: 1.4,
      letterSpacing: 0,
      color: '#E73123',
      margin: '0 0 16px 0'
    },
    capabilitiesGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px 32px',
      marginBottom: 24
    },
    capabilityItem: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      textTransform: 'capitalize',
      color: '#090909',
      margin: 0,
      paddingLeft: 20,
      position: 'relative'
    },
    bullet: {
      position: 'absolute',
      left: 0,
      top: 14,
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: '#E73123'
    },
    imageWrap: {
      position: 'relative',
      flex: 1,
      minHeight: 400,
      overflow: 'hidden',
      opacity: 1
    },
    sectionImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'top center',
      display: 'block'
    },
    ctaBtn: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      display: 'inline-block',
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: 14,
      padding: '14px 28px',
      background: '#E73123',
      color: '#FFFFFF',
      textDecoration: 'none',
      textTransform: 'uppercase',
      textAlign: 'center'
    }
  };

  const capabilities = [
    'Bored cast-in-situ piles',
    'Rotary drilling piling',
    'Deep foundation systems for high-load structures',
    'Driven precast concrete piles',
    'Soil testing and geotechnical coordination'
  ];

  return React.createElement('section', { style: styles.section, className: 'section-padding' },
    React.createElement('div', { style: styles.inner, className: 'section-inner-wrap' },
      React.createElement('div', { style: styles.leftCol, className: 'section-text-col' },
        React.createElement('div', { style: styles.overlineRow },
          React.createElement('p', { style: styles.overline }, 'DEEP FOUNDATIONS'),
          React.createElement('div', { style: styles.overlineRule })
        ),
        React.createElement('div', { style: styles.titleRow },
          React.createElement('span', { style: styles.titleRed }, 'PRECAST'),
          React.createElement('span', { style: styles.titleBlack }, ' & CAST-IN-SITU'),
          React.createElement('br'),
          React.createElement('span', { style: styles.titleBlack }, 'PILING SOLUTIONS')
        ),
        React.createElement('p', { style: styles.body },
          'We specialize in both precast and cast-in-situ piling systems, offering customized solutions based on soil conditions, load requirements, and structural design.'
        ),
        React.createElement('h3', { style: styles.capabilitiesHeading }, 'Our Capabilities Include:'),
        React.createElement('div', { style: styles.capabilitiesGrid },
          capabilities.map(function (item, i) {
            return React.createElement('p', { key: i, style: styles.capabilityItem },
              React.createElement('span', { style: styles.bullet }),
              item
            );
          })
        ),
        React.createElement('p', { style: styles.body },
          'Using state-of-the-art hydraulic rigs, drilling equipment, and modern testing methods, we ensure optimal depth, alignment, and load-bearing capacity. Our team follows strict quality control measures and safety protocols to deliver foundations built for durability and resilience.'
        )
      ),
      React.createElement('div', { style: styles.rightCol, className: 'section-image-col' },
        React.createElement('div', { style: styles.imageWrap, className: 'section-image-wrap' },
          React.createElement('img', {
            src: '/deepfoundations.jpg',
            alt: 'Deep foundation and piling construction',
            style: styles.sectionImage
          }),
          React.createElement('a', { href: '#contact', style: styles.ctaBtn }, 'REQUEST A CONSULTATION')
        )
      )
    )
  );
}

export default ServicesDeepFoundationsSection;
